export default __webpack_public_path__ + "static/media/mTop_2_p2.ce2f93ab.jpeg";